<template>
  <div class="header">
    <div class="h-container">
      <div class="h-logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="h-city" @click="changeCity">
        <a-icon type="environment" class="h-city-icon" />{{ cur_city.label }}
      </div>
    </div>
    <a-menu v-model="current" mode="horizontal" :inlineCollapsed="false">
      <a-menu-item key="index">
        <router-link :to="{ name: 'Index' }">首页</router-link>
      </a-menu-item>
      <a-menu-item key="car">
        <router-link :to="{ path: '/cars' }">特惠品牌</router-link>
      </a-menu-item>
      <a-menu-item key="mall">
        <router-link :to="{ path: '/quote' }">报价</router-link>
      </a-menu-item>
      <a-menu-item key="news">
        <router-link :to="{ path: '/news' }">资讯</router-link>
      </a-menu-item>
      <a-menu-item key="dealer">
        <router-link :to="{ path: '/dealers' }">经销商</router-link>
      </a-menu-item>
      <a-menu-item key="quote">
        <router-link :to="{ path: '/quote/askprice' }">询价</router-link>
      </a-menu-item>
    </a-menu>

    <div class="city-container" :style="style" v-if="city_visibile">
      <div class="city__header">
        <a-icon type="close" class="city-icon__back" />
        <span>选择城市</span>
      </div>
      <div class="city__body">
        <div class="city__province" v-for="item in cities" :key="item.value">
          <span
            class="protxt"
            style="
              display: block;
              text-align: left;
              padding: 10px 20px 0;
              font-weight: bold;
            "
            >{{ item.label }}</span
          >
          <ul>
            <li
              data="340100"
              v-for="city in item.children"
              :key="city.value"
              @click="setCity(city)"
            >
              {{ city.label }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cities from "@/data/city.js";
import { getRegionFromIP } from "@/api/region";
export default {
  name: "TopMenu",
  data() {
    return {
      style: "",
      cities: cities,
      city_visibile: false,
      cur_city: {
        label: "加载中",
        value: 0,
      },
    };
  },
  props: {
    current: {
      type: Array,
      default: () => {
        return [];
      },
      required: false,
    },
  },
  mounted() {
    const clientHeight = window.screen.height;
    this.style = "height:" + clientHeight + "px;";
    let curCity = localStorage.getItem("_m_cur_city");
    if (curCity === null) {
      this.getRegion();
    } else {
      try {
        let curCityObj = JSON.parse(curCity);
        this.cur_city.label = curCityObj.c_name;
        this.cur_city.value = curCityObj.c_id;
      } catch (e) {
        this.cur_city.label = "北京";
      }
    }
    console.log(curCity);
  },
  computed: {},
  methods: {
    getRegion() {
      getRegionFromIP().then((resp) => {
        this.cur_city.label = resp.data.city_name;
        this.cur_city.value = resp.data.city_id;
      });
    },
    changeCity() {
      this.city_visibile = true;
    },
    setCity(city) {
      this.cur_city.label = city.label;
      this.cur_city.value = city.value;
      this.city_visibile = false;
      localStorage.setItem(
        "_m_cur_city",
        JSON.stringify({
          c_id: city.value,
          c_name: city.label,
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  margin-top: 0;
  z-index: 99;
  top: 0;
  .h-container {
    width: 100%;
    height: 3rem;
    background: #e67e22;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h-logo {
      display: flex;
      padding-left: 0.5rem;
      img {
        height: 2rem;
      }
    }
    .h-city {
      padding-right: 0.5rem;
      color: #ffffff;
      font-weight: 400;
      .h-city-icon {
        margin-right: 0.2rem;
      }
    }
  }
}

.city-container {
  position: fixed;
  top: 0px;
  z-index: 11;
  width: 100%;
  overflow-y: auto;
  // background-color: #ffffff;
  background-color: #f2f2f2;
  overflow: scroll;
  .city__header {
    position: relative;
    margin: 0;
    padding: 0;
    height: 40px;
    background-color: #f2f2f2;
    span {
      display: block;
      font-size: 16px;
      color: #333;
      line-height: 40px;
      text-align: center;
    }
    .city-icon__back {
      position: absolute;
      z-index: 1;
      top: 3px;
      left: 0;
      bottom: 0;
      width: 15px;
      height: 15px;
      padding: 0.65rem 0.75rem;
      line-height: 0;
    }
  }

  .city__body {
    .city__province {
      background-color: #fafafa;
      font-size: 14px;
      color: #666666;
      overflow: hidden;
      text-align: center;
      ul {
        list-style: none;
      }
      ul li {
        width: 33.3%;
        float: left;
        padding: 8px 0px;
      }
    }
  }
}
</style>
